import { REHYDRATE } from 'redux-persist/lib/constants';
import {
	LOGIN_USER,
	LOGIN_USER_SUCCESS,
	LOGIN_USER_ERROR,
	LOGIN_USER_BY_APPLE_ID,
	LOGIN_USER_BY_FACEBOOK,
	LOGOUT_USER,

	AUTH_ERROR,

	REGISTER_USER,
	REGISTER_USER_SUCCESSFUL,
	REGISTER_USER_FAILED
} from './actionTypes';

import loginReducer from './login/reducer';
import registerReducer from './register/reducer';

const initialState = {};

const authReducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case REHYDRATE:
			if (payload && payload.user)
				state = {
					...state,
					...payload.user,
				};
			else
				state = {
					...state,
				};
			break;
		case LOGIN_USER:
			state = {
				...loginReducer(state, { type, payload })
			};
			break;
		case LOGIN_USER_SUCCESS:
			state = {
				...loginReducer(state, { type, payload })
			};
			break;
		case LOGIN_USER_ERROR:
			state = {
				...loginReducer(state, { type, payload })
			};
			break;
		case LOGIN_USER_BY_APPLE_ID:
			state = {
				...loginReducer(state, { type, payload })
			};
			break;
		case LOGIN_USER_BY_FACEBOOK:
			state = {
				...loginReducer(state, { type, payload })
			};
			break;
		case LOGOUT_USER:
			state = {
				...loginReducer(state, { type, payload })
			};
			break;
		case AUTH_ERROR:
			state = {
				...loginReducer(state, { type, payload })
			};
			break;


		case REGISTER_USER:
			state = {
				...state,
				...registerReducer(state, { type, payload }),
			}
			break;
		case REGISTER_USER_SUCCESSFUL:
			state = {
				...state,
				...registerReducer(state, { type, payload }),
			}
			break;
		case REGISTER_USER_FAILED:
			state = {
				...state,
				...registerReducer(state, { type, payload }),
			}
			break;

		default:
			state = { ...state };
			break;
	}
	return state;
};

export default authReducer;
